export default ($axios) => ({
    $axios,

    async fetch({
        entity_type,
        entity_id,
    }) {
        return await $axios.get(`/files?entity_type=${entity_type}&entity_id=${entity_id}`)
    },

    async add(form) {
        return await $axios.post('/files', form)
    },

    async remove(entity_id) {
        return await $axios.delete(`/files/${entity_id}`)
    },
})
